import {
  DynamicList,
  VersionDetail,
} from '@/interfaces/model/general/dynamicList';

export const NewDynamicList: DynamicList = {
  id: 0,
  name: '',
  description: '',
  created_by: null,
  total: 0,
  last_count: 0,
  created_at: '',
  updated_at: '',
  deleted_at: null,
  version_updated_at: null,
  version_details: [] as VersionDetail[],
  regulation_urls: {},
};
